#@export GliveBooking.Presenters.Book

class GliveBooking.Presenters.Book extends BookingV2.Presenters.Base

  module: 'glive-booking'

  toHash: ->
    isSellable = @model.get 'isSellable'
    isDisabled = !@model.isReadyToBook() or !isSellable

    isAvailable: @model.get 'isAvailable'
    isDisabled: isDisabled
    isPromNight: window.promNight
    isSellable: isSellable
    isSoldOut: @model.get 'isSoldOut'
